import { Entry } from '../Entry'

export function Entry20220415() {
  return (
    <Entry title="15/04/2022 - v3.0.0-RC2">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12564/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
